"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var PersonalIntegration = _interopRequireWildcard(require("../../../PersonalIntegration"));

var _gift = require("../../store/gift/gift.selector");

var _useCheckIntegrationsReconnect = require("../../hooks/useCheckIntegrationsReconnect");

var _EmailIntegration = require("./EmailIntegration.styles");

/**
 * Display social integration links.
 *
 * @param {object} props
 * @param {string} [props.linkToIntegration=''] - If it passed instead of social links will be rendered anchor with
 * passed link.
 * @return {React.ReactNode}
 */
var EmailIntegrationConnect = function EmailIntegrationConnect(_ref) {
  var linkToIntegration = _ref.linkToIntegration,
      integrationStrategy = _ref.integrationStrategy,
      onSetupIntegration = _ref.onSetupIntegration;
  var dispatch = (0, _reactRedux.useDispatch)();
  var classes = (0, _EmailIntegration.useStyles)();
  var isDkimProvider = (0, _reactRedux.useSelector)(_gift.getIsDkimEmailProvider);
  var currentPath = "".concat(window.location.pathname).concat(window.location.search);
  (0, _useCheckIntegrationsReconnect.useCheckIntegrationsReconnect)();
  var onClick = (0, _react.useCallback)(function (event) {
    event.preventDefault();
    var scopes = {
      email: !isDkimProvider,
      calendar: true
    };
    var service = event.currentTarget.dataset.service;
    dispatch(PersonalIntegration.actions.openIntegrationService(integrationStrategy === 'salesforce' ? {
      service,
      script: integrationStrategy,
      scopes
    } : {
      service,
      path: currentPath,
      scopes
    }));
  }, [currentPath, dispatch, integrationStrategy, isDkimProvider]);
  var handleSetupIntegrationClick = (0, _react.useCallback)(function () {
    return onSetupIntegration(true);
  }, [onSetupIntegration]);
  return linkToIntegration ? /*#__PURE__*/_react.default.createElement(_material.Button, {
    variant: "contained",
    color: "secondary",
    fullWidth: true,
    target: "__blank",
    className: (0, _classnames.default)('No-Shadow', classes.anchorButton),
    href: linkToIntegration,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      color: "inherit",
      size: 1.1,
      icon: "external-link"
    }),
    onClick: handleSetupIntegrationClick
  }, "Set up integration in your personal settings") : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "inline-block",
    mr: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.EmailIntegrationButton, {
    signIn: true,
    variant: "google",
    onClick: onClick,
    "data-service": "google"
  })), /*#__PURE__*/_react.default.createElement(_ui.EmailIntegrationButton, {
    signIn: true,
    variant: "outlook",
    onClick: onClick,
    "data-service": "outlook"
  }));
};

EmailIntegrationConnect.propTypes = {
  integrationStrategy: _propTypes.default.string,
  linkToIntegration: _propTypes.default.string,
  onSetupIntegration: _propTypes.default.func.isRequired
};
EmailIntegrationConnect.defaultProps = {
  linkToIntegration: '',
  integrationStrategy: undefined
};

var _default = /*#__PURE__*/(0, _react.memo)(EmailIntegrationConnect);

exports.default = _default;